export const SUCCESS = "success";

export const REPORT_DATE_TYPES = {
  CUSTOM: "custom",
  TODAY: "today",
  YESTERDAY: "yesterday",
  LAST_7_DAYS: "last7days",
  LAST_30_DAYS: "last30days",
  LAST_90_DAYS: "last90days",
  LAST_180_DAYS: "last180days",
  // Category-wise report date types
  ONE_DAY: "1day",
  LAST_1_WEEK: "last1week",
  LAST_1_MONTH: "last1month",
  LAST_3_MONTHS: "last3months",
  LAST_6_MONTHS: "last6months",
};

export const API_ENDPOINTS = {
  LOGIN_V2: "/v2/login",
  DASHBOARD_V2: "/v2/restaurants/dashboard",
  RESTAURANT_DETAILS: "/v2/restaurants/details",
  MENU: "/v2/menu",
  CATEGORY: "/v2/menu/category",
  GST: "/v2/restaurants/gst",
  REFRESH_TOKEN: "/v2/refresh",
  REPORTS_V2: "/v2/orders/reports",
  ITEM_WISE_REPORTS_V2: "/v2/reports/item-wise",
  CATEGORY_WISE_REPORTS_V2: "/v2/reports/category-wise",
  ORDER_TYPE_REVENUE_REPORTS_V2: "/v2/reports/order-type-revenue",
  CANCELLED_BILL_REPORTS_V2: "/v2/reports/cancelled-bill-reports",
  CANCELLED_BILL_ITEM_REPORTS_V2: "/v2/reports/cancelled-bill-item-reports",
  DOWNLOAD_REPORT: "/v2/reports/download-report",
  EXPORT_REPORT: "/v2/reports/export-report",
  REVENUE_REPORTS_V2: "/v2/reports/revenue-report",
  ORDER_LIVE_V2: "/v2/orders/live",
  ORDER: "/v2/orders",
  ORDER_PAYMENT: "/v2/orders/payment",
  ORDER_BY_ID: (id) => `/v2/orders/${id}`,
  QUICK_ORDER: "/v2/orders/complete-order",
  PARTNERS: "/v2/restaurants/partner-details",
  PRINTER_CONFIG: "/v2/restaurants/printer-config",
  DATE_WISE_ITEM_REPORT: "/v2/reports/date-wise-item-report",
  STAFF: "/v2/restaurant-staff",
  PARTNER_ORDER_REPORT: "/v2/reports/partner-order-reports",
  MENU_IMAGE: "/v2/menu/image",
  CATEGORY_IMAGE: "/v2/menu/category/category-image",

  // coupons
  VERIFY_COUPON: "/v1/coupons/verify",

  // e-bill
  EBILL_PDF: (orderId) => `/v2/orders/ebill/pdf/${orderId}`,
};
